import { render, staticRenderFns } from "./RecommendBlock.vue?vue&type=template&id=b77983bc&scoped=true"
import script from "./RecommendBlock.vue?vue&type=script&lang=js"
export * from "./RecommendBlock.vue?vue&type=script&lang=js"
import style0 from "./RecommendBlock.vue?vue&type=style&index=0&id=b77983bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77983bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b77983bc')) {
      api.createRecord('b77983bc', component.options)
    } else {
      api.reload('b77983bc', component.options)
    }
    module.hot.accept("./RecommendBlock.vue?vue&type=template&id=b77983bc&scoped=true", function () {
      api.rerender('b77983bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invention/RecommendBlock.vue"
export default component.exports